/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_VENUES (state, venues) {
    state.venues = venues
  },
  REMOVE_RECORD (state, itemId) {
    const pageIndex = state.venues.findIndex((u) => u.ID === itemId)
    state.venues.splice(pageIndex, 1)
  }
}
